module.exports = __webpack_public_path__ + "img/ic_64_flame.7a2624e7.svg";